export const getAnalyticsToolbarActions = ({
  isRTL = false,
  locked = false,
  allowAddWidget = true,
  allowResetLayout = true,
  allowExport = false,
  exporting = false,
  exportMode = ''
} = {}) => {
  const actions = [];

  if (allowExport) {
    actions.push({
      id: 'export_pdf',
      label: exporting && exportMode === 'pdf' ? (isRTL ? 'جار التصدير' : 'Exporting') : (isRTL ? 'تصدير PDF' : 'Export PDF'),
      icon: exporting && exportMode === 'pdf' ? 'fa-spinner fa-spin' : 'fa-file-pdf',
      tone: 'ghost'
    });
    actions.push({
      id: 'export_pptx',
      label: exporting && exportMode === 'pptx' ? (isRTL ? 'جار التصدير' : 'Exporting') : (isRTL ? 'تصدير PPTX' : 'Export PPTX'),
      icon: exporting && exportMode === 'pptx' ? 'fa-spinner fa-spin' : 'fa-file-powerpoint',
      tone: 'primary'
    });
  }

  if (locked) {
    return actions;
  }

  if (allowResetLayout) {
    actions.push({
      id: 'reset_layout',
      label: isRTL ? 'إعادة التخطيط' : 'Reset layout',
      icon: 'fa-rotate-left',
      tone: 'ghost'
    });
  }

  if (allowAddWidget) {
    actions.push({
      id: 'add_widget',
      label: isRTL ? 'إضافة عنصر' : 'Add widget',
      icon: 'fa-plus',
      tone: 'primary'
    });
  }

  return actions;
};
